<template>
  <a-table
    class="remediation-table"
    :class="{ 'dark-theme-table': darkTheme }"
    rowKey="numero"
    :pagination="false"
    :scroll="{ y: 300 }"
    :columns="columns"
    :dataSource="this.remediationData"
    :expandIconColumnIndex="3"
    :expandIconAsCell="false"
    :locale="{ emptyText: 'Ici s\'affichera les détails que vous avez révisé' }"
    :customRow="(record) => {
      return {
        on: {
          click: () => {
            handleRowClick(record)
          }
        }
      }
    }" >
    <template slot="remarque" slot-scope="text">
      <div numero="remarque" style="font-size: 15px;">
        {{ minimizedText(text) }}
      </div>
    </template>
  </a-table>
</template>
<script>
import { mapState } from 'vuex'
import moment from 'moment'

const columns = [{
  title: 'Date',
  dataIndex: 'dateRemediation',
  width: '7%',
  defaultSortOrder: 'descend',
  sorter: (a, b) => moment(a.dateRemediation, 'DD.MM.YYYY') - moment(b.dateRemediation, 'DD.MM.YYYY')
}, {
  title: 'Élève',
  dataIndex: 'loginCreateur',
  width: '10%',
  sorter: (a, b) => a.loginCreateur.localeCompare(b.loginCreateur, 'fr', { ignorePunctuation: true })
}, {
  title: 'Classe',
  dataIndex: 'classeCreateur',
  width: '12%',
  sorter: (a, b) => a.classeCreateur.localeCompare(b.classeCreateur, 'fr', { ignorePunctuation: true })
}, {
  title: 'Travail',
  dataIndex: 'titreTravail',
  width: '20%'
}, {
  title: 'Remarque',
  dataIndex: 'remarque',
  width: '51%',
  scopedSlots: { customRender: 'remarque' }
}]

export default {
  name: 'RemediationTable',
  data () {
    return {
      columns
    }
  },
  methods: {
    moment,
    minimizedText (text) {
      if (text.length > 100) {
        return text.toString().substring(0, 100) + '...'
      }
      return text
    },
    handleRowClick (record) {
      this.$router.push(`/details/${record.num_tblTravauxIndex}#${record.numero}`)
    }
  },
  computed: {
    ...mapState({
      remediationData: state => state.remediation.remediationData,
      darkTheme: state => state.darkTheme
    })
  }
}
</script>
<style scoped lang="scss">
</style>
